import React, { Component } from 'react';
import { routes } from '../routes/Routes';
import _authService from '../modules/AuthService';

class InvalidLicenceError extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {        
        this.getIpAddress(); 
    }

    getIpAddress = async (ev) => {

        this.setState({ isLoading: true });
        try {
          const response = await _authService.getClientIP();
          if (response) {
            localStorage.clear();
            sessionStorage.clear();

            document.addEventListener('contextmenu', (e) => {
                e.preventDefault();
            });      
            this.setState({ isLoading: false })
          }
          else {
            this.props.history.push(routes.home.basePath)
          }
        } catch (e) {
          this.setState({ isLoading: false })
        }
      }

    render() {       
        return (
            <div className="container  analysisWrap pt-3 pb-3 p-sm-4 p-md-2">
                <div className="container w-50 analysisWrap pt-3 pb-3 p-sm-4 p-md-2">
                    <div className="">
                        <div className="card">
                            <div className="card-header text-light font-weight-bold" style={{background: '#d12828', fontSize: '13px'}}>
                                Licence Expired
                            </div>
                            <div className="card-body">
                                <div className="text-danger">
                                    <label style={{fontSize: '15px'}}>Your license expired. You must renew your license in order to access Online Exam portal. Contact admin to renew your license.</label>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default InvalidLicenceError;